import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { EnrollSearchStore } from 'widgets/EnrollSearch'

export type AICallingAgentEnrollSearchStore = EnrollSearchStore<ICallingListResponse>

export const createAICallingAgentEnrollSearchStore = (): AICallingAgentEnrollSearchStore =>
  new EnrollSearchStore<ICallingListResponse>({
    perPage: 10,
    getKey: (item) => item.id,
    fetchItems: async ({ term, offset, limit, cancelToken }) => {
      const { data } = await AiCallingApi.getList(
        { offset, limit, search: term || undefined, status: 'active' },
        { cancelToken }
      )
      return { items: data.items, total: data.total }
    },
  })
